import React, { useEffect, useMemo, useState } from 'react';
import Logo from '../ui/icons/Logo';
import ResetPasswordContainer from '../ui/containers/ResetPasswordContainer';
import ResetPasswordFormContainer from '../ui/containers/ResetPasswordFormContainer';
import { PremiumInput } from 'modules/emergencies/components/ui/inputs/customInput';
import ResetPasswordButton from '../ui/buttons/ResetPasswordButton';
import ErrorText from '../ui/text/ErrorText';
import * as http from 'utils/http';
import config from 'config';
import { Loading } from 'components/Loading';
import { useHistory } from 'react-router-dom';
import Title from '../ui/text/Title';
import Label from '../ui/text/Label';
import { LoginIcon } from 'assets/icons/icon_by_config/LoginIcon';

const SetNewPassword = ({ token, t }) => {
  const history = useHistory();
  const [password, setPassword] = useState('');
  const [repeatPassword, setRepeatPassword] = useState('');
  const [hasError, setHasError] = useState(false);
  const [isTokenValid, setIsTokenValid] = useState(false);
  const [success, setSuccess] = useState();
  const [isFetching, setIsFetching] = useState(true);
  const disabledButton = useMemo(
    () => password === '' || repeatPassword === '',
    [repeatPassword, password]
  );

  useEffect(() => {
    const validateToken = async () => {
      try {
        await http.rawPost(`${config.BASE_URL}/v1/check_reset_pwd_token/`, { token });
        setIsTokenValid(true);
      } catch (err) {
        setIsTokenValid(false);
      } finally {
        setIsFetching(false);
      }
    };
    validateToken();
  }, [token]);

  const redirectToLogin = () => {
    history.push('/login');
  };
  const handleClick = async () => {
    const isValidPassword = repeatPassword === password;
    setHasError(!isValidPassword);
    if (isValidPassword) {
      try {
        await http.rawPost(`${config.BASE_URL}/v1/reset_pwd/`, { password, token });
        setSuccess(true);
        redirectToLogin();
      } catch (error) {
        setSuccess(false);
      } finally {
        setIsFetching(false);
      }
    }
  };

  if (isFetching)
    return (
      <ResetPasswordContainer>
        <Loading size={40} />
      </ResetPasswordContainer>
    );

  return (
    <ResetPasswordContainer>
      <Logo alt="logo" src={LoginIcon()} />
      <Title>{t.title}</Title>
      {!isTokenValid ? (
        <ResetPasswordFormContainer>
          <Label>{t.invalid_token}</Label>
          <ResetPasswordButton onClick={redirectToLogin} size="L" fullWidth text={t.redirect} />
        </ResetPasswordFormContainer>
      ) : (
        <ResetPasswordFormContainer>
          <PremiumInput
            width={'100%'}
            type="password"
            label={t.password}
            value={password}
            isRequired={true}
            hasError={hasError}
            onChange={(e) => {
              setPassword(e.target.value);
              setHasError(false);
              setSuccess();
            }}
          />
          <PremiumInput
            width={'100%'}
            type="password"
            label={t.confirm_password}
            value={repeatPassword}
            isRequired={true}
            hasError={hasError}
            onChange={(e) => {
              setRepeatPassword(e.target.value);
              setHasError(false);
              setSuccess();
            }}
          />
          {hasError && <ErrorText>{t.matchError}</ErrorText>}
          {success === false && <ErrorText>{t.success_error}</ErrorText>}
          <ResetPasswordButton
            onClick={handleClick}
            size="L"
            fullWidth
            text={t.button}
            disabled={disabledButton}
          />
        </ResetPasswordFormContainer>
      )}
    </ResetPasswordContainer>
  );
};

export default SetNewPassword;
